<template>
  <Loading
    :contentSize="true"
    :state="loading"
  >
    <div
      v-if="data"
      class="wrapper"
    >
      <div class="layout1">
        <div class="row1">
          <div class="cell1">
            <h2>{{ $t( "DatasourceObjects" ) }}</h2>

            <div class="dataSource">
              {{ $t( "ChooseDataSource" ) }}<br />
              <select
                v-model="system"
              >
                <option value="">{{ $t( "AllSystems" ) }}</option>
                <option
                  v-for="( d, i ) in data.DetailsByOrigin"
                  :value="i"
                >{{ data._DataSources && ( i in data._DataSources ) ? data._DataSources[ i ] : i }}</option>
              </select>
            </div>

            <Apexchart
              height="400em"
              type="donut"
              :options="donut.options"
              :series="donut.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0">
              <tr>
                <td></td>
                <th>{{ $t( "Total" ) }}</th>
                <td class="val">{{ numFormats( donut.series[0] + donut.series[1] + donut.series[2] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + donut.options.colors[0]" /></td>
                <th>{{ donut.options.labels[0] }}</th>
                <td class="val">{{ numFormats( donut.series[0] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + donut.options.colors[1]" /></td>
                <th>{{ donut.options.labels[1] }}</th>
                <td class="val">{{ numFormats( donut.series[1] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + donut.options.colors[2]" /></td>
                <th>{{ donut.options.labels[2] }}</th>
                <td class="val">{{ numFormats( donut.series[2] ) }}</td>
              </tr>
            </table>
          </div>
          <div class="cell2">
            <Apexchart
              type="bar"
              height="490em"
              :options="bar.options"
              :series="bar.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0">
              <tr>
                <td><div class="clr" :style="'background-color:' + bar.options.colors[3]" /></td>
                <th>{{ bar.options.labels[3] }}</th>
                <td class="val">{{ numFormats( bar.original[3] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar.options.colors[2]" /></td>
                <th>{{ bar.options.labels[2] }}</th>
                <td class="val">{{ numFormats( bar.original[2] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar.options.colors[1]" /></td>
                <th>{{ bar.options.labels[1] }}</th>
                <td class="val">{{ numFormats( bar.original[1] ) }}</td>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar.options.colors[0]" /></td>
                <th>{{ bar.options.labels[0] }}</th>
                <td class="val">{{ numFormats( bar.original[0] ) }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row2" v-if="dataS._referenceClass">
          <div class="cell1">
            <h2>{{ $t( "ReferenceObjects" ) }}</h2>

            <table class="legend" cellspacing="2" cellpadding="0">
              <tr v-for="( v, i ) in treemap.series[0].data">
                <td><div class="clr" :style="'background-color:' + treemap.options.colors[ i ]" /></td>
                <th>{{ $t( "BasedOnSources", { n: v.x } ) }}</th>
                <td class="val">{{ v.y }}</td>
              </tr>
            </table>
          </div>
          <div class="cell2">
            <Apexchart
              type="treemap"
              height="300em"
              :options="treemap.options"
              :series="treemap.series"
            />
          </div>
        </div>
      </div>

      <div
        class="layout2"
        v-if="dataS && dataS.PropertiesStat"
      >
        <div class="row1">
          <div class="cell1">
            <h2>{{ $t( "DataSourceObjectProperties" ) }}</h2>
            <h2>{{ $t( "FillRate" ) }}</h2>
            <Apexchart
              class="yClick"
              type="bar"
              :height="bar2.height"
              :options="bar2.options"
              :series="bar2.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0">
              <tr>
                <td><div class="clr" :style="'background-color:' + bar2.options.colors[0]" /></td>
                <th>{{ bar2.series[0].name }}</th>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar2.options.colors[1]" /></td>
                <th>{{ bar2.series[1].name }}</th>
              </tr>
            </table>
          </div>
          <div class="cell2">
            <h2 style="padding-top: 3.3em">{{ $t( "ViolationsShare" ) }}</h2>

            <Apexchart
              type="bar"
              :height="bar3.height"
              :options="bar3.options"
              :series="bar3.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0" style="padding-left: 1.5em">
              <tr>
                <td><div class="clr" :style="'background-color:' + bar3.options.colors[0]" /></td>
                <th>{{ bar3.series[0].name }}</th>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar3.options.colors[1]" /></td>
                <th>{{ bar3.series[1].name }}</th>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar3.options.colors[2]" /></td>
                <th>{{ bar3.series[2].name }}</th>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div
        class="layout3"
        v-if="dataS && dataS._referenceClass"
      >
        <div class="row1">
          <div class="cell1">
            <h2>{{ $t( "RefObjProps" ) }}</h2>
            <h2>{{ $t( "FillRate" ) }}</h2>

            <Apexchart
              type="bar"
              :height="bar4.height"
              :options="bar4.options"
              :series="bar4.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0">
              <tr>
                <td><div class="clr" :style="'background-color:' + bar4.options.colors[0]" /></td>
                <th>{{ bar4.series[0].name }}</th>
              </tr>
              <tr>
                <td><div class="clr" :style="'background-color:' + bar4.options.colors[1]" /></td>
                <th>{{ bar4.series[1].name }}</th>
              </tr>
            </table>
          </div>
          <div class="cell2">
            <h2 style="padding-top: 3.3em">{{ $t( "SourceOfValues" ) }}</h2>

            <Apexchart
              type="bar"
              :height="bar5.height"
              :options="bar5.options"
              :series="bar5.series"
            />

            <table class="legend" cellspacing="2" cellpadding="0" style="padding-left: 1.5em">
              <tr
                v-for="( d, i ) in bar5.origins"
              >
                <td><div class="clr" :style="'background-color:' + bar5.options.colors[ i ]" /></td>
                <th>{{ d.name }}</th>
                <td class="val">{{ numFormats( d.total ) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

    <Modal
      class="selectedD"
      :show="selected.show"
      :title="`«${ selected.id in selected.attrs ? selected.attrs[ selected.id ].name : selected.id }»`"
      acceptButtonText="Ok"
      cancelButtonText=""
      @accept="$set( selected, 'show', false )"
      @close="$set( selected, 'show', false )"
    >
      <Apexchart
        v-if="selected.data"
        type="bar"
        :height="barSelected.height"
        :options="barSelected.options"
        :series="barSelected.series"
      />
      <div
        v-else
        class="empty"
      >
        {{ $t( "NoRulesForProp" ) }}
      </div>
    </Modal>
  </Loading>
</template>

<script>

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import api from "@/api"
import ls from "@/ls"

import Icon from "@/components/Icon";
import Button from "@/components/Button";
import File from "@/components/File";
import Loading from "@/components/Loading";
import Modal from "../components/Modal";
import user from "../store/modules/user";

const percentByNum = ( n, max ) => {
  return ( n * 100 / max ).toFixed( 2 );
};

export default {
  name: "pageQuality",

  components: {
    Icon,
    Loading,
    Modal,
    Button,
    File
  },

  i18n: {
    messages: {
      ru: {
        DatasourceObjects:"Объекты из источника данных",
        ChooseDataSource: "Выберите источник",
        NoConsViols: "Без нарушений",
        BlockViols:  "С блокирующими нарушениями",
        InfViols:    "Только с информационными нарушениями",
        QualityRequestErr:"Ошибка запроса качества данных",
        AllSystems:       "Все",

        Total:                  "Общее количество",
        NoConstraintViolations: "Без нарушений",
        BlockingViolations:     "С блокирующими нарушениями",
        InformativeViolations:  "Только с информационными нарушениями",

        HasLinkedObjectsFromOtherDataSources: "Имеют связанные объекты из других источников данных",
        HasReferenceObject: "Имеют эталонный объект",
        HasConsolidationError: "Имеют ошибку консолидации",
        DontHaveReferenceObject: "Не имеют эталонного объекта",

        ReferenceObjects: "Эталонные объекты",

        BasedOnSources: "	На основе {n} источника",

        DataSourceObjectProperties: "Свойства объектов из источников данных",
        FillRate: "Заполнение",
        HasValue: "Есть значение",
        NoValue: "Нет значения",

        ViolationsShare: "Наличие нарушений",
        barNoConsViols: "Без нарушений",
        barBlockViols:  "С блокирующими нарушениями",
        barInfViols:    "Только с информационными нарушениями",
        RefObjProps:    "Свойства эталонных объектов",
        SourceOfValues: "Источник значений",

        NoRulesForProp: "Нет правил для данного свойства"
      },

      en: {
        DatasourceObjects:"Data source objects",
        ChooseDataSource: "Choose data source",
        NoConsViols: "No constraint violations",
        BlockViols:  "Blocking violations",
        InfViols:    "Informative violations",
        QualityRequestErr:"Quality request error",
        AllSystems:       "All",

        Total:                  "Total",
        NoConstraintViolations: "No constraint violations",
        BlockingViolations:     "Blocking violations",
        InformativeViolations:  "Informative violations",

        HasLinkedObjectsFromOtherDataSources: "Has linked objects from other data sources",
        HasReferenceObject: "Has reference object",
        HasConsolidationError: "Has consolidation error",
        DontHaveReferenceObject: "Don’t have a reference object",

        ReferenceObjects: "Reference objects",

        BasedOnSources: "Produced from {n} source",

        DataSourceObjectProperties: "Data source object properties",
        FillRate: "Fill rate",
        HasValue: "Has value",
        NoValue: "No value",

        ViolationsShare: "Violations share",
        barNoConsViols: "No constraint violations",
        barBlockViols:  "Blocking violations",
        barInfViols:    "Informative violations",
        RefObjProps:    "Reference object properties",
        SourceOfValues: "Source of values",

        NoRulesForProp: "There are no rules for this property"
      },

      kz: {
        DatasourceObjects:"Data source objects",
        ChooseDataSource: "Choose data source",
        NoConsViols: "No constraint violations",
        BlockViols:  "Blocking violations",
        InfViols:    "Informative violations",
        QualityRequestErr:"Quality request error",
        AllSystems:       "All",

        Total:                  "Total",
        NoConstraintViolations: "No constraint violations",
        BlockingViolations:     "Blocking violations",
        InformativeViolations:  "Informative violations",

        HasLinkedObjectsFromOtherDataSources: "Has linked objects from other data sources",
        HasReferenceObject: "Has reference object",
        HasConsolidationError: "Has consolidation error",
        DontHaveReferenceObject: "Don’t have a reference object",

        ReferenceObjects: "Reference objects",

        BasedOnSources: "Produced from {n} source",

        DataSourceObjectProperties: "Data source object properties",
        FillRate: "Fill rate",
        HasValue: "Has value",
        NoValue: "No value",

        ViolationsShare: "Violations share",
        barNoConsViols: "No constraint violations",
        barBlockViols:  "Blocking violations",
        barInfViols:    "Informative violations",
        RefObjProps:    "Reference object properties",
        SourceOfValues: "Source of values",

        NoRulesForProp: "There are no rules for this property"
      }
    }
  },

  data() {
    return {
      loading:true,
      system: "",
      data:   null,

      classId:       "DataSourcePerson",
      endpoint: "bookdemo",
      attrs:    {},
      attrsRefO:{},

      selected: {
        show: false,
        id: null,
        attrs: {},
        data: null
      }
    };
  },

  async mounted() {
    this.loading = true;

    if ( this.$route ) {
      if ( this.$route.params.endpoint && this.$route.params.classId ) {
        this.endpoint = this.$route.params.endpoint;
        this.classId = this.$route.params.classId;
      }
    }


    await this.dataGet();
    this.loading = false;
  },

  methods: {
    numFormats( n ) {
      const parts = n.toString().split( "." );
      parts[ 0 ] = parts[ 0 ].replace( /\B(?=(\d{3})+(?!\d))/g, " " );
      return parts.join( "." );
    },

    async endpointsGet() {
      let endpoints = {};

      try {
        const ans = await this.$options.api.post.json(
          "/endpoints",
            {
              ...this.queryStdParams,
              clientId: this.clientId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        endpoints = ans.items;
      }
      catch ( e ) {
        console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestErr' ), message: e.message, type: "error" } );
      }

      this.endpoints = endpoints;
    },

    async dataGet() {
      try {
        let ans = await this.$options.api.post.json(
          "/schemas",
          {
            ...this.queryStdParams,
            id:       this.classId,
            endpoint: this.endpoint,
            clientId: this.clientId
          }
        );
        if ( ans && ans.item && ans.item.attrs ) {
          this.attrs = ans.item.attrs;
        }

        ans = await this.$options.api.post.json(
          "/quality/charts",
          {
            ...this.queryStdParams,
            id:       this.classId,
            endpoint: this.endpoint,
            clientId: this.clientId
          }
        );
        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

        if ( !ans.data ) throw new Error( "malformed server answer" );

        const data = ans.data;

        this.attrsRefO = {};
        ans = await this.$options.api.post.json(
          "/schemas",
          {
            ...this.queryStdParams,
            id:       data._referenceClass.id,
            endpoint: this.endpoint,
            clientId: this.clientId
          }
        );
        if ( ans && ans.item && ans.item.attrs ) {
          this.attrsRefO = ans.item.attrs;
        }

        this.data = data;
      }
      catch ( e ) {
        console.error( "QUALITY REQUEST ERROR: request is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( "QualityRequestErr" ), message: e.message, type: "error" } );
      }
    },

    async qualityStatGet( id ) {
      let data = null;

      if ( id ) {
        try {
          let ans = await this.$options.api.post.json(
            "/quality",
            {
              ...this.queryStdParams,
              id:       this.classId,
              attrs:    [ id ],
              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );
          if ( ans && ans.quality && ans.quality.attrs && ans.quality.shapes ) {

            const attrs = ans.quality.attrs;
            if ( id in attrs ) {
              if ( attrs[ id ].shapes.length ) data = { shapes: attrs[ id ].shapes.map( i => ( { id: i.id, severity: i.severity, ...ans.quality.shapes[ i.id ] } ) ) };
            }
          }
        }
        catch ( e ) {
          console.error( "QUALITY REQUEST ERROR: request is failed with " + e.message, e.stack );
          this.$root.$emit( "notify", { header: this.$t( "QualityRequestErr" ), message: e.message, type: "error" } );
        }
      }

      return data;
    }

  },

  computed: {
    queryStdParams() {
      return {
        ...this.queryStd,
        lang:     this.langInterf,
      };
    },
    
    dataS() {
      if ( this.data && this.system && ( this.system in this.data.DetailsByOrigin ) ) return this.data.DetailsByOrigin[ this.system ];

      return this.data;
    },

    donut() {
      const ret = {
        options:  {
          colors: [ "#92D050", "#E00000", "#FFC000" ],
          labels:  [ this.$t( "NoConsViols" ), this.$t( "BlockViols" ), this.$t( "InfViols" ) ],
          legend: { show: false },
          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },
        series:   []
      };

      if ( this.dataS ) {
        const v = this.dataS.Violations;
        const w = this.dataS.Warnings;
        let n = this.dataS.Total - v - w;
        if ( n < 0 ) n = 0;
        ret.series.push( n, v, w );
      }

      return ret;
    },

    bar() {
      const ret = {
        options:  {
          colors: [ "#FFC000", "#E00000", "#92D050", "#0070C0" ],
          labels:  [ this.$t( "DontHaveReferenceObject" ), this.$t( "HasConsolidationError" ), this.$t( "HasReferenceObject" ), this.$t( "HasLinkedObjectsFromOtherDataSources" ) ],
          legend: { show: false },
          plotOptions: {
            bar: {
              horizontal: true,
              distributed:true,
              barHeight:  "50%",
            },
          },
          dataLabels: {
            enabled:    true,
            textAnchor: "start",
            formatter: v => v.toFixed( 0 ) + "%",
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },

          grid: {
            show: true,
            yaxis: {
              lines: { show: false }
            }
          },

          yaxis: {
            show: false
          },

          xaxis: {
            forceNiceScale: false,
            max: 100,
            labels: {
              formatter: v => v.toFixed( 0 ) + "%"
            }
          },
          tooltip: {
            y: {
              formatter( v, o ) {
                return ret.original[ o.dataPointIndex ];
              },

              title: {
                formatter( v ) {
                  return "";
                }
              }
            },
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },
        series:   [ { data: [] } ],
        original: []
      };

      if ( this.dataS ) {
        ret.original = [ this.dataS.NoRef, this.dataS.HasConsError, this.dataS.HasRef, this.dataS.HasSameas ];
        const total = ret.original.reduce( ( a, i ) => { a += i; return a; }, 0 );
        for ( const v of ret.original ) ret.series[0].data.push( percentByNum( v, total ) );
      }

      return ret;
    },

    treemap() {
      const ret = {
        options:  {
          colors: [ "#FFC000", "#E00000", "#92D050", "#0070C0", "#00FFE2", "#FF3C00", "#00F87D", "#A56CFF", "#A84300", "#FF00FF" ],

          plotOptions: {
            treemap: {
              distributed: true
            }
          },

          dataLabels: {
            enabled:    true,
            textAnchor: "start",
            formatter( v, o ) { return o.value; },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },

          tooltip: {
            y: {
              title: {
                formatter: v => this.$t( "BasedOnSources", { n: v } ) + ":"
              }
            },
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },
        series:   [ { data: [] } ]
      };

      if ( this.dataS && this.dataS._referenceClass && this.dataS._referenceClass.StatBySources ) {
        const rc = this.dataS._referenceClass;
        for ( const sid in rc.StatBySources ) {
          if ( rc.StatBySources.hasOwnProperty( sid ) ) {
            const v = rc.StatBySources[ sid ];
            ret.series[0].data.push( { x: sid, y: v } );
          }
        }
      }

      return ret;
    },

    bar2() {
      const ret = {
        height: "490em",

        options:  {
          colors: [ "#4472C4", "#ED7D31" ],
          legend: { show: false },

          chart: {
            stacked: true,
            stackType: "100%",
            events: {
              xAxisLabelClick: async ( event, chartContext, config ) => {
                const i = config.labelIndex;
                let j = 0;
                for ( const id in this.dataS.PropertiesStat ) {
                  if ( this.dataS.PropertiesStat.hasOwnProperty( id ) ) {
                    if ( j === i ) {
                      this.loading = true;

                      const data = await this.qualityStatGet( id );

                      this.selected = {
                        show: true,
                        id,
                        attrs: this.attrs,
                        data
                      };

                      this.loading = false;

                      break;
                    }
                    j++;
                  }
                }
              }
            }
          },

          plotOptions: {
            bar: {
              horizontal: true
            },
          },

          xaxis: {
            show: false,
            categories: [],
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          yaxis: {
            show: true,
            labels: {
              show: true,
              maxWidth: "10em",
              style: {
                fontSize: "1.2em",
                colors: "#000000"
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          grid: {
            show: false
          },

          tooltip: {
            y: {
              formatter: ( v, o ) => {
                return ret.original[ o.dataPointIndex ] + " / " + this.dataS.Total;
              },
              title: {
                formatter: v => {
                  return this.$t( "FillRate" ) + ":";
                }
              }
            },
            marker: {
              show: false
            }
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },

        series:   [],
        original: [
        ]
      };

      if ( this.dataS ) {
        const total = this.dataS.Total;

        ret.series.push(
          {
            name: this.$t( "HasValue" ),
            data: []
          },
          {
            name: this.$t( "NoValue" ),
            data: []
          },
        );

        const data = this.dataS;
        if ( data ) {
          for ( let aid in data.PropertiesStat ) {
            if ( data.PropertiesStat.hasOwnProperty( aid ) ) {
              const s = data.PropertiesStat[ aid ];
              ret.options.xaxis.categories.push( aid in this.attrs ? this.attrs[ aid ].name : aid );
              ret.original.push( s.Values );
              const hv = ( s.Values / total * 100 ).toFixed( 2 );
              const nv = 100 - hv;
              ret.series[0].data.push( hv );
              ret.series[1].data.push( nv );
            }
          }

          ret.height = ( ret.original.length * 50 ) + "em";
        }
      }

      return ret;
    },

    bar3() {
      const ret = {
        height: "490em",

        options:  {
          colors: [ "#92D050", "#FFC000", "#E00000" ],
          legend: { show: false },
          chart: {
            stacked: true,
            stackType: "100%"
          },

          plotOptions: {
            bar: {
              horizontal: true
            },
          },

          xaxis: {
            show: false,
            categories: [],
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          yaxis: {
            show: false,
            labels: {
              show: false,
              maxWidth: "10em",
              style: {
                fontSize: "1.2em",
                colors: "#000000"
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          grid: {
            show: false
          },

          tooltip: {
            y: {
              formatter( v, o ) {
                return ret.original[ o.dataPointIndex ][ o.seriesIndex ];
              }
            }
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },

        series:   [],
        original: [
        ]
      };

      if ( this.dataS ) {
//        const total = this.dataS.Total;

        ret.series.push(
          {
            name: this.$t( "NoConsViols" ),
            data: []
          },
          {
            name: this.$t( "InfViols" ),
            data: []
          },
          {
            name: this.$t( "BlockViols" ),
            data: []
          }
        );

        const data = this.dataS;
        if ( data ) {
          for ( let aid in data.PropertiesStat ) {
            if ( data.PropertiesStat.hasOwnProperty( aid ) ) {
              const s = data.PropertiesStat[ aid ];
              ret.options.xaxis.categories.push( aid in this.attrs ? this.attrs[ aid ].name : aid );

/*
const vs = Math.ceil( Math.random() * total );
const ws = Math.ceil( Math.random() * ( total - s.Violations ) );
const v1 = total - vs - ws;
const v2 = ws;
const v3 = vs;
*/

              const total = s.Values;

              const v1 = total - s.Violations - s.Warnings;
              const v2 = s.Warnings;
              const v3 = s.Violations;

              ret.original.push( [ v1, v2, v3 ] );

              ret.series[0].data.push( ( v1 / total * 100 ).toFixed( 2 ) );
              ret.series[1].data.push( ( v2 / total * 100 ).toFixed( 2 ) );
              ret.series[2].data.push( ( v3 / total * 100 ).toFixed( 2 ) );
            }
          }

          ret.height = ( ret.original.length * 50 ) + "em";
        }
      }

      return ret;
    },

    bar4() {
      const ret = {
        height: "490em",

        options:  {
          colors: [ "#4472C4", "#ED7D31" ],
          legend: { show: false },
          chart: {
            stacked: true,
            stackType: "100%"
          },

          plotOptions: {
            bar: {
              horizontal: true
            },
          },

          xaxis: {
            show: false,
            categories: [],
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          yaxis: {
            show: true,
            labels: {
              show: true,
              maxWidth: "10em",
              style: {
                fontSize: "1.2em",
                colors: "#000000"
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          grid: {
            show: false
          },

          tooltip: {
            y: {
              formatter: ( v, o ) => {
                return ret.original[ o.dataPointIndex ] + " / " + this.dataS.Total;
              },
              title: {
                formatter: v => {
                  return this.$t( "FillRate" ) + ":";
                }
              }
            },
            marker: {
              show: false
            }
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },

        series:   [],
        original: [
        ]
      };

      if ( this.dataS ) {
        const total = this.dataS.Total;

        ret.series.push(
          {
            name: this.$t( "HasValue" ),
            data: []
          },
          {
            name: this.$t( "NoValue" ),
            data: []
          },
        );

        const data = this.dataS._referenceClass;
        if ( data && data.PropertiesStat ) {
          for ( let aid in data.PropertiesStat ) {
            if ( data.PropertiesStat.hasOwnProperty( aid ) ) {
              const s = data.PropertiesStat[ aid ];

              ret.options.xaxis.categories.push( aid in this.attrsRefO ? this.attrsRefO[ aid ].name : aid );

              ret.original.push( s.Values );
              const hv = ( s.Values / total * 100 ).toFixed( 2 );
              const nv = 100 - hv;
              ret.series[0].data.push( hv );
              ret.series[1].data.push( nv );
            }
          }

          ret.height = ( ret.original.length * 50 ) + "em";
        }
      }

      return ret;
    },

    bar5() {
      const ret = {
        height: "490em",

        options:  {
          colors: [ "#FFC000", "#ED7D31", "#A5A5A5", "#4472C4", "#5B9DD5", "#E0ED31", "#31ED8C", "#31C7ED", "#5A31ED" ],
          legend: { show: false },
          chart: {
            stacked: true,
            stackType: "100%"
          },

          plotOptions: {
            bar: {
              horizontal: true
            },
          },

          xaxis: {
            show: false,
            categories: [],
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          yaxis: {
            show: false,
            labels: {
              show: false,
              maxWidth: "10em",
              style: {
                fontSize: "1.2em",
                colors: "#000000"
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },

          grid: {
            show: false
          },

          tooltip: {
            y: {
              formatter( v, o ) {
                return ret.original[ o.dataPointIndex ][ o.seriesIndex ];
              }
            }
          },

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },

        series:   [],
        origins:  [],
        original: []
      };

      if ( this.dataS ) {
        for ( const i in this.data.DetailsByOrigin ) {
          if ( this.data.DetailsByOrigin.hasOwnProperty( i ) ) {
            const name = this.data._DataSources && ( i in this.data._DataSources ) ? this.data._DataSources[ i ] : i;
            ret.origins.push(
                {
                  id: i,
                  name,
                  total: 0
                }
            );
          }
        }

        for ( const o of ret.origins ) {
          ret.series.push(
            {
              name: o.name,
              data: []
            }
          );
        }

        const data = this.dataS._referenceClass;
        if ( data && data.PropsByOrigin && data.PropertiesStat ) {
          for ( let aid in data.PropertiesStat ) {
            if ( data.PropertiesStat.hasOwnProperty( aid ) ) {
              const ps = aid in data.PropsByOrigin ? data.PropsByOrigin[ aid ] : {};

              ret.options.xaxis.categories.push( aid in this.attrsRefO ? this.attrsRefO[ aid ].name : aid );

              const od = [];
              let sum = 0;
              for ( const o of ret.origins ) {
                const v = o.id in ps ? ps[ o.id ] : 0;
                o.total += v;

                sum += v;
                od.push( v );
              }

              ret.original.push( od );

              let i = 0;
              for ( const o of ret.origins ) {
                ret.series[ i ].data.push( ( od[ i ] / sum * 100 ).toFixed( 2 ) );
                i++;
              }
            }
          }
          ret.height = ( ret.original.length * 50 ) + "em";
        }
        else ret.height = ( Object.keys( data.PropertiesStat ).length * 50 ) + "em";
      }

      return ret;
    },

    barSelected() {
      const colors = {
        "http://www.w3.org/ns/shacl#Violation": "#E00000",
        "http://www.w3.org/ns/shacl#Warning":   "#FFC000",
        "http://www.w3.org/ns/shacl#Info":      "#92D050"
      };

      const ps = this.dataS ? this.dataS.PropertiesStat[ this.selected.id ] : {};

      const ret = {
        height: "90%",

        options:  {
          legend: { show: false },
          plotOptions: {
            bar: {
              horizontal: true,
              distributed:true
            },
          },

          grid: {
            show: true,
            yaxis: {
              lines: { show: true }
            }
          },

          yaxis: {
            show: true
          },

          xaxis: {
            show: false,
            categories: [],
            forceNiceScale: false,
            max: 100,
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },
          tooltip: {
            y: {
              formatter( v, o ) {
                return ret.original[ o.dataPointIndex ].count + " / " + ps.Values;
              },

              title: {
                formatter( v ) {
                  return "";
                }
              }
            },
          },
          colors: [
            o => {
              const s = ret.original[ o.dataPointIndex ];
              return colors[ s && s.severity && ( s.severity in colors ) ? s.severity : "http://www.w3.org/ns/shacl#Info" ];
            }
          ],

          states: {
            hover: {
             filter: {
                type: "lighten",
                value: 0.0005
              }
            }
          }
        },
        series:   [ { data: [] } ],
        original: []
      };

      if ( this.dataS && this.selected && this.selected.data && this.selected.data.shapes ) {
        for ( const s of this.selected.data.shapes ) {
          ret.options.xaxis.categories.push( s.name );
          ret.original.push( { count: s.count, severity: s.severity } );

          const c = s.count > ps.Values ? ps.Values : s.count;
          ret.series[0].data.push( percentByNum( c, ps.Values ) );
        }
      }

      return ret;
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 1em;
}

.wrapper h2 {
  font-size: 1.5em;
  font-weight: bold;
  margin: 1em 0 2em 0;
  color: #4D4D4D;
}

.wrapper h3 {
  font-weight: bold;
  margin: 2em 0 0.5em 0;
}

.selector {
  position: relative;
  display: inline-block;
  border-radius: 0.2em;
  border: solid 1px #000000;
  padding: 0.25em;
  vertical-align: middle;
  margin-right: 1em;
}
.selector > select {
  width: 9.5em;
  padding: 0.1em 0.2em;
  background-color: transparent;
  border: none;
  font-size: inherit;
  font-size: 1.2em;
}
.selector::after {
  content: "";
  position: absolute;
  width: 1em;
  height: 0.9em;
  right: 0.1em;
  top: 0.5em;
  background-color: #FFFFFF;
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2016%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%3Cpath%20d%3D%22m0%200%208%208%208-8z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
  background-size: 0.8em auto;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  pointer-events: none;
  font-size: inherit;
  font-size: 1.2em;
}

.button {
  display: block;
  width: 12em;
  margin-top: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.limit {
  font-size: 1.2em;
  padding: 0.3em;
  border-radius: 0.2em;
  border: solid 1px #000000;
  width: 10em;
}

.chunkSize {
  font-size: 1.2em;
  padding: 0.3em;
  border-radius: 0.2em;
  border: solid 1px #000000;
  width: 10em;
}

.openMetadataViewModal::v-deep .container {
  min-width: 32vw !important;
}



h2 {
  font-size: 2em;
  margin: 1em 0;
}

.layout1,
.layout2,
.layout3 {
  width: 100%;
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-direction: column;
  padding: 3em;
}

.layout1 > .row1,
.layout1 > .row2,
.layout2 > .row1,
.layout3 > .row1 {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-direction: row;
  flex-wrap: nowrap;
}

.layout1 > .row1 > .cell1,
.layout1 > .row1 > .cell2,
.layout1 > .row2 > .cell1,
.layout1 > .row2 > .cell2,
.layout2 > .row1 > .cell1,
.layout2 > .row1 > .cell2,
.layout3 > .row1 > .cell1,
.layout3 > .row1 > .cell2 {
  width: 50%;
  position: relative;
}

.layout1 > .row1 > .cell1,
.layout1 > .row2 > .cell1,
.layout2 > .row1 > .cell1,
.layout3 > .row1 > .cell1 {
  margin-right: 5em;
  box-sizing: border-box;
}

.layout1 > .row2 > .cell1,
.layout1 > .row2 > .cell2 {
  margin-top: 3em;
}

.layout1 .dataSource {
  position: absolute;
  top: 1em;
  right: 0;
}
.layout1 .dataSource select {
  font: inherit;
  font-size: 1.5em;
  min-width: 10em;
}

.legend {
  width: 100%;
}
.legend td,
.legend th {
  background-color: #E9EBF5;
  padding: 0.2em 0.4em;
  text-align: left;
}
.legend td:first-child {
  width: 1em;
}
.legend .clr {
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
.legend .val {
  width: 20%;
  text-align: right;
}

.selectedD::v-deep .body.scrollContent {
  width: 45vw;
  height: 80vh;
  overflow-x: hidden !important;
}
.selectedD .empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
}

.selectedD::v-deep .apexcharts-tooltip-title {
  max-width: 30em;
  white-space: normal;
}
</style>
<style>
.yClick .apexcharts-yaxis-label:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
